// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"02038404","292":"a5df7f47"}[chunkId] + ".chunk.css";
};